import styled from "@emotion/styled";
import { useFetchTerms } from "hooks/queries/terms/termsQueries";
import parse from "html-react-parser";

type TProps = {
  termsId: number;
  currentTermIndex: number;
};
export const TermsViewer = ({ termsId }: TProps) => {
  const { data } = useFetchTerms(termsId);

  return (
    <>
      {data ? (
        <CkWrapper className="ck-content">{parse(data?.contents || "")}</CkWrapper>
      ) : (
        <EmptyDivForLoading />
      )}
    </>
  );
};

const CkWrapper = styled.div`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video,
  input {
    font: revert;
    margin: revert;
    padding: revert;
    border: revert;
    line-height: 1.5;
    font-family: "Pretendard", sans-serif !important;
    color: ${({ theme }) => theme.color.black};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 0 0.5rem;
    line-height: 1.1;
    font-family: "Pretendard", sans-serif !important;
    color: ${({ theme }) => theme.color.black};
  }
  max-width: 720px;
  margin: 0 auto;

  .strong {
    ${({ theme }) => theme.font.Body_h};
    margin-top: 32px;
    margin-bottom: 24px;
  }

  .sentence {
    ${({ theme }) => theme.font.Subtitle2};
    color: ${({ theme }) => theme.color.mono[70]};
  }
  /* overflow: scroll; */
`;

const EmptyDivForLoading = styled.div`
  width: 100%;
  height: 100vh;
`;
